import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
Vue.use(Vuex);
class StoreUserPrisClass {
    constructor() {
        this.element = [];
        this.operation = [];
    }
}
class StoreUserClass {
    constructor() {
        this.privileges = new StoreUserPrisClass();
    }
}
export default new Vuex.Store({
    state: {
        token: '',
        // user: { privileges: [], },
        user: new StoreUserClass(),
        sessionTimeout: null,
        device: {
            list: [],
            serials: [],
            typeList: ['台式西林设备', '台式安瓿设备', '综合配药设备'],
            onStateList: [{
                    prop: '正常使用',
                    class: 'on-state-info-primary'
                }, {
                    prop: '未装机',
                    class: 'on-state-info-orange'
                }, {
                    prop: '停用',
                    class: 'on-state-info-red'
                }, {
                    prop: '入场',
                    class: ''
                }, {
                    prop: '入仓',
                    class: ''
                }, {
                    prop: '测试',
                    class: ''
                }, {
                    prop: '临床',
                    class: 'on-state-info-primary'
                }]
        },
        app: {
            type: '',
        },
        config: {
            server: {
                isTestEnv: false
            }
        },
        recipels: {
            record: {
                catalog: {
                    year: []
                }
            }
        },
        malfunction: {
            dates: [],
            categories: [],
            modules: [],
            years: [],
        },
        hospitals: {
            list: [],
            loading: false
        }
    },
    getters: {
        malfunctionDates: state => state.malfunction.dates,
        malfunctionCategories: state => state.malfunction.categories,
        malfunctionModules: state => state.malfunction.modules,
        malfunctionYears: state => state.malfunction.years,
        recRecordCatalog: state => state.recipels.record.catalog.year,
        isSrvTestEnv: state => state.config.server.isTestEnv,
        appType: state => state.app.type,
        isThirdApp: state => Boolean(state.app.type),
        isDingTalk: state => Boolean(/dingtalk/i.test(state.app.type)),
        userInfo: state => state.user,
        currentPrivileges: state => state.user.privileges,
        token: state => state.token,
        sessionTimeout: state => state.sessionTimeout,
        deviceList: state => state.device.list,
        deviceSerialList: state => state.device.serials,
        deviceTypeList: state => state.device.typeList,
        hospitalsList: state => state.hospitals.list,
        hospitalsLoading: state => state.hospitals.loading,
        deviceOnStateList: state => state.device.onStateList,
    },
    mutations: {
        setMalfunctionDates(state, val) {
            state.malfunction.dates = val;
        },
        setMalfunctionCategories(state, val) {
            state.malfunction.categories = val;
        },
        setMalfunctionModules(state, val) {
            state.malfunction.modules = val;
        },
        setMalfunctionYears(state, val) {
            state.malfunction.years = val;
        },
        setRecRecordCatalogYear(state, val) {
            state.recipels.record.catalog.year = val;
        },
        setRecRecordCatalog(state, val) {
            state.recipels.record.catalog = val || {};
        },
        setSrvCfgTestEnv(state, val) {
            state.config.server.isTestEnv = val;
        },
        setAppType(state, val) {
            state.app.type = val;
        },
        setDeviceSerialList(state, val) {
            state.device.serials = val;
        },
        setDeviceList(state, val) {
            state.device.list = val;
        },
        setCurrentPrivileges(state, val) {
            state.state.user.privileges = val;
        },
        setToken(state, val) {
            state.token = val;
            // 同时保存到localStorage
            if (window.localStorage) {
                if (val) {
                    window.localStorage.setItem('token', val);
                }
                else {
                    window.localStorage.removeItem('token');
                }
            }
        },
        setSessionTimeout(state, val) {
            state.sessionTimeout = val;
        },
        checkLogin(state) {
            if (window.localStorage) {
                let usrInfoLocal = {};
                try {
                    usrInfoLocal = window.localStorage.getItem('userInfo') || '';
                    const isDataNotOk = /^null$|^undfined$/i.test(usrInfoLocal.trim());
                    if (isDataNotOk)
                        usrInfoLocal = {};
                    else
                        usrInfoLocal = JSON.parse(usrInfoLocal);
                }
                catch (e) { }
                state.user = usrInfoLocal;
                // 恢复token
                try {
                    const tokenLocal = window.localStorage.getItem('token') || '';
                    if (tokenLocal && tokenLocal !== 'null' && tokenLocal !== 'undefined') {
                        state.token = tokenLocal;
                    }
                }
                catch (e) { }
            }
        },
        login(state, user) {
            if (window.localStorage) {
                window.localStorage.setItem('userInfo', JSON.stringify(user));
            }
            state.user = user;
        },
        logout(state) {
            if (window.localStorage) {
                window.localStorage.removeItem('userInfo');
                window.localStorage.removeItem('token');
            }
            state.user = {};
            state.token = '';
        },
        setHospitalsList(state, val) {
            state.hospitals.list = val;
        },
        setHospitalsLoading(state, val) {
            state.hospitals.loading = val;
        }
    },
    actions: {
        async fetchDeviceModeCatalog({ commit, getters, state }, op) {
            return axios.get('/api/device/catalog', { params: { ...(op || {}) } }).then((res) => {
                const result = res && res.data && res.data.result || [];
                // @ts-ignore
                const list = [].concat((state.device.typeList || []), (result.type || [])).filter((v, i, a) => a.indexOf(v) === i);
                state.device.typeList = list;
                return result;
            }).catch((e) => console.log('获取设备类型错误,' + (e && (e.info || e.error || e.result))));
        },
        async fetchMalfunctionCatalog({ commit, getters }, op) {
            return axios.get('/api/malfunctions/categories', { params: { ...(op || {}) } }).then((res) => {
                const result = res && res.data && res.data.result || [];
                commit('setMalfunctionDates', (result.dates || '').split(',').filter((v) => !!v) || []);
                commit('setMalfunctionCategories', (result.categories || '').split(',').filter((v) => !!v) || []);
                commit('setMalfunctionModules', (result.modules || '').split(',').filter((v) => !!v) || []);
                commit('setMalfunctionYears', (result.years || '').split(',').filter((v) => !!v) || []);
                return { dates: getters.malfunctionDates, modules: getters.malfunctionModules, categories: getters.malfunctionCategories, years: getters.years };
            }).catch((e) => console.log('获取调配记录目录分组错误,' + (e && (e.info || e.error || e.result))));
        },
        async fetchRecRecordCatalog({ commit }) {
            return axios.get('/api/recipels/manual/catalog', { params: {} }).then((res) => {
                const listDevice = res && res.data && res.data.result || [];
                commit('setRecRecordCatalog', listDevice);
                return listDevice;
            }).catch((e) => console.log('获取调配记录目录分组错误,' + (e && (e.info || e.error || e.result))));
        },
        async logout({ commit }) {
            const that = this;
            try {
                await axios.post('/api/users/logout');
            }
            catch (e) {
                console.log('logout error:', e);
            }
            commit('setToken', String());
            commit('logout', String());
        },
        async fetchDevices({ commit }) {
            return axios.get('/api/device', { params: {} }).then((res) => {
                const listDevice = res && res.data && res.data.result || [];
                commit('setDeviceList', listDevice);
                return listDevice;
            }).catch((e) => console.log('设备列表获取出错,' + (e && (e.info || e.error || e.result))));
        },
        async fetchDeviceSerialList({ commit }) {
            return axios.get('/api/device/serial', { params: {} }).then((res) => {
                const listDevice = res && res.data && res.data.result || [];
                commit('setDeviceSerialList', listDevice);
                return listDevice;
            }).catch((e) => console.log('设备机型列表获取出错,' + (e && (e.info || e.error || e.result))));
        },
        async fetchHospitals({ commit }, params = {}) {
            commit('setHospitalsLoading', true);
            return axios.get('/api/hospital', { params: { simple: true, ...params } }).then((res) => {
                const hospitalsList = res && res.data && res.data.result || [];
                commit('setHospitalsList', hospitalsList);
                commit('setHospitalsLoading', false);
                return hospitalsList;
            }).catch((e) => {
                commit('setHospitalsLoading', false);
                console.log('医院列表获取出错,' + (e && (e.info || e.error || e.result)));
                return [];
            });
        },
    },
});
